export const validate = (
  length: number,
  message = `mindestens ${length} Zeichen benötigt`
) => (value: string) => (value || "").length >= length || message;
